<template>
  <div class="plan-wrap" v-loading="loading" customClass="loadingclass">
    <div class="plan-header">
      <el-button
        @click="backTable"
        class="back-btn"
        type="text"
        icon="el-icon-arrow-left"
        >返回</el-button
      >
    </div>
    <div class="plan-main">
      <div class="left-step">
        <Step
          ref="stepRef"
          @backToTable="backToTable"
          @changeStep="scrollToView"
        ></Step>
      </div>
      <div class="plan-content">
        <div class="content-scroll">
          <div class="plan-center-content">
            <!-- 模板 -->
            <header-tpl ref="headerTplRef"></header-tpl>
            <!-- 广告组 -->
            <div class="setp-wrap" id="step1">
              <ad-group ref="adgroupRef"></ad-group>
            </div>
            <!-- 快手应用 -->
            <div class="setp-wrap" id="step2">
              <kuaishou-app ref="kuaishouAppRef"></kuaishou-app>
            </div>
            <!-- 基础设置 -->
            <div class="setp-wrap" id="step3">
              <base-set ref="baseSetRef"></base-set>
            </div>
            <!-- 定向包 -->
            <div class="setp-wrap" id="step4">
              <direct-pkg ref="directPkgRef"></direct-pkg>
            </div>
            <!-- 预算与出价 -->
            <div class="setp-wrap" id="step5">
              <budget-bid ref="budgetbidRef"></budget-bid>
            </div>
            <!-- 创意组 -->
            <div class="setp-wrap" id="step6">
              <create-group ref="creategroupRef"></create-group>
            </div>
            <!-- 创意标题 -->
            <div class="setp-wrap" id="step7">
              <create-title ref="createtitleRef"></create-title>
            </div>
            <!-- 落地页（安卓时显示） -->
            <div
              class="setp-wrap"
              id="step8"
              v-if="this.checkedApp.os_type === 'ANDROID'"
            >
              <Ldy ref="ldyRef"></Ldy>
            </div>
            <div class="button-list">
              <el-button class="my-btn" type="primary" @click="toPreview"
                >提交预览</el-button
              >
              <el-button class="my-btn border-btn" @click="showModal"
                >保存模板</el-button
              >
              <el-button class="my-btn border-btn" @click="resetAllData"
                >全部重置</el-button
              >
            </div>
          </div>
          <!-- 分配规则 -->
          <div class="num-table-wrap">
            <allocation-rule></allocation-rule>
          </div>
        </div>
      </div>
    </div>

    <!-- 保存模板弹框 -->
    <el-dialog title="保存模板" :visible.sync="showSaveModal" width="450px">
      <div class="modal-body">
        <el-form
          :model="saveModalData"
          label-width="80px"
          :rules="rules"
          ref="saveModalRef"
        >
          <el-form-item label="保存方式:" v-show="showSaveMethods">
            <el-radio-group v-model="saveModalData.isAdd" class="radio-group">
              <el-radio :label="0">更新模板</el-radio>
              <el-radio :label="1">另存为模板</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="模板名称:" prop="templateName">
            <el-input
              :disabled="saveModalData.isAdd === 0"
              v-model="saveModalData.templateName"
              placeholder="请输入模板名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="描述:">
            <el-input
              type="textarea"
              v-model="saveModalData.templateDesc"
              placeholder="请输入描述"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="footer-wrap">
          <el-button @click="showSaveModal = false">取 消</el-button>
          <el-button type="primary" @click="saveTpl">确 定</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Step from "./subPlan/step.vue";
import HeaderTpl from "./subPlan/headerTpl.vue";
import AdGroup from "./subPlan/adGroup.vue";
import KuaishouApp from "./subPlan/kuaishouApp.vue";
import BaseSet from "./subPlan/baseSet.vue";
import DirectPkg from "./subPlan/directPkg.vue";
import BudgetBid from "./subPlan/budgetBid.vue";
import CreateGroup from "./subPlan/creativeGroup.vue";
import CreateTitle from "./subPlan/creativeTitle.vue";
import Ldy from "./subPlan/ldy.vue";
import AllocationRule from "./subPlan/allocationRules.vue";
import { mapState } from "vuex";
import { preview, createTemplate } from "@/api/promotion-kuaishou.js";
export default {
  components: {
    Step,
    HeaderTpl,
    AdGroup,
    KuaishouApp,
    BaseSet,
    DirectPkg,
    BudgetBid,
    CreateGroup,
    CreateTitle,
    Ldy,
    AllocationRule,
  },
  data() {
    return {
      loading: false,
      showSaveModal: false,
      showSaveMethods: false,
      saveModalData: {
        templateName: "",
        templateDesc: "",
        id: null,
        isAdd: 1, //1新增， 0覆盖
      },
      rules: {
        templateName: [
          { required: true, message: "模板名称必填", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    backToTable() {
      this.$router.go(-1);
    },
    scrollToView(step) {
      let element = document.getElementsByClassName("content-scroll")[0];
      let height = document.getElementById("step" + step).offsetTop - 10; //计算需要向上移动的距离
      element.scroll({
        top: height,
        behavior: "smooth",
      });
    },
    debounce(fn, wait) {
      var timer = null;
      return function () {
        if (timer !== null) {
          clearTimeout(timer);
        }
        timer = setTimeout(fn, wait);
      };
    },
    listenScroll() {
      let content = document.getElementsByClassName("content-scroll")[0];
      let that = this;
      content.addEventListener(
        "scroll",
        this.debounce(function () {
          let flag = true; //是否对比完全部
          for (let i = 1; i <= 6; i++) {
            let el = document.getElementById("step" + i);
            if (el.getBoundingClientRect().top - 180 > 0) {
              let step = i - 1;
              that.$refs.stepRef.curStep = step === 0 ? 1 : step;
              flag = false;
              break;
            }
          }
          if (flag) {
            that.$refs.stepRef.curStep = 6;
          }
        }, 200),
        false
      );
    },
    checkAllData(allData) {
      let targetingList = allData.draft_adset.targeting;
      let hasfilter = targetingList.find(
        (item) => item.filter_converted_level !== 0
      ); //过滤已转化用户不是不限
      let budgetBidList = allData.draft_adset.budget_and_bid;
      let hasFM = budgetBidList.find((item) => item.ocpx_action_type === 1); //设置了封面点击数
      if (hasfilter && hasFM) {
        this.$message.warning(
          "优化目标选择封面点击量时，过滤已转化用户必须选择不限"
        );
      } else {
        return true;
      }
    },
    toPreview() {
      this.checkData()
        .then(() => {
          let params = {
            advertiser_id: this.advertiser_id,
            split_rule: this.split_rule,
            draft_campaign: this.draft_campaign,
            draft_adset: this.draft_adset,
            draft_ad: this.draft_ad,
            checkedApp: this.checkedApp,
            web_urls: this.web_urls.filter((item) => item.web_url),
          };
          let checkRes = this.checkAllData(params);
          if (checkRes) {
            this.loading = true;
            preview(params).then((res) => {
              this.loading = false;
              if (res.code === "0000") {
                this.$router.push({
                  name: "kuaishouPreview",
                  params: {
                    previewData: res.previews,
                    templateId: res.templateId,
                  },
                });
              } else {
                this.$message.error("预览失败!!!");
              }
            });
          }
        })
        .catch(() => {
          this.$message.warning("请检查数据填写是否完整");
        });
    },
    showModal() {
      this.$refs.adgroupRef
        .checkData()
        .then(() => {
          //保存快手应用数据
          this.$refs.kuaishouAppRef.saveInStore();
          //保存定向包数据
          this.$refs.directPkgRef.saveData();
          //保存预算出价数据
          this.$refs.budgetbidRef.saveData();
          //保存创意标题数据
          this.$refs.createtitleRef.saveInStore();
          //保存落地页数据
          if (this.$refs.ldyRef) {
            this.$refs.ldyRef.saveInStore();
          }

          this.saveModalData.templateName = "";
          this.saveModalData.templateDesc = "";
          this.saveModalData.isAdd = 1;
          let tplMsg = this.$refs.headerTplRef.tplMsg;
          if (tplMsg.tplName !== "") {
            this.showSaveMethods = true;
            this.saveModalData.id = tplMsg.tplId;
            this.saveModalData.templateName = tplMsg.tplName;
            this.saveModalData.templateDesc = tplMsg.tplDes;
            this.saveModalData.isAdd = 0;
          }
          this.showSaveModal = true;
        })
        .catch(() => {
          this.$message.warning("广告组数据必填");
        });
    },
    saveTpl() {
      this.$refs.saveModalRef.validate((valid) => {
        if (valid) {
          let tplData = {
            advertiser_id: this.advertiser_id,
            split_rule: this.split_rule,
            draft_campaign: this.draft_campaign,
            draft_adset: this.draft_adset,
            draft_ad: this.draft_ad,
            checkedApp: this.checkedApp,
            web_urls: this.web_urls.filter((item) => item.web_url),
          };
          let parmas = {
            templateName: this.saveModalData.templateName,
            templateDesc: this.saveModalData.templateDesc,
            isAdd: this.saveModalData.isAdd,
            data: JSON.stringify(tplData),
            platType: 3,
          };
          if (this.saveModalData.isAdd === 0) {
            parmas.templateId = this.saveModalData.id;
          }
          this.loading = true;
          createTemplate(parmas).then((res) => {
            this.loading = false;
            if (res.code === "0000") {
              this.$message({
                message: "模板保存成功",
                type: "success",
              });
              this.showSaveModal = false;
            }
          });
        }
      });
    },
    resetAllData() {
      this.$confirm("该操作会重置所有表单项, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          window.location.reload();
        })
        .catch(() => {});
    },
    checkData() {
      return Promise.all([
        this.$refs.headerTplRef.checkData(),
        this.$refs.adgroupRef.checkData(),
        this.$refs.kuaishouAppRef.checkData(),
        this.$refs.baseSetRef.checkData(),
        this.$refs.directPkgRef.checkData(),
        this.$refs.budgetbidRef.checkData(),
        this.$refs.creategroupRef.checkData(),
        this.$refs.createtitleRef.checkData(),
        //落地页
        this.$refs.ldyRef ? this.$refs.ldyRef.checkData() : Promise.resolve(),
      ]);
    },
    backTable() {
      this.$router.push("/promotion.html");
    },
  },
  computed: {
    ...mapState({
      //账号
      advertiser_id: (state) => state.PromotionKuaishou.adCount.advertiserId,
      //分配规则
      split_rule: (state) => state.PromotionKuaishou.split_rule,
      //广告组
      draft_campaign: (state) => state.PromotionKuaishou.draft_campaign,
      //广告计划
      draft_adset: (state) => state.PromotionKuaishou.draft_adset,
      //广告创意
      draft_ad: (state) => state.PromotionKuaishou.draft_ad,
      //选择的产品
      checkedApp: (state) => state.PromotionKuaishou.checkedApp,
      //落地页
      web_urls: (state) => state.PromotionKuaishou.web_urls,
    }),
  },
  mounted() {
    this.listenScroll();
  },
};
</script>

<style lang="less" scoped>
.plan-wrap {
  .plan-header {
    .back-btn {
      color: rgba(0, 0, 0, 0.85);
      font-weight: 500;
      font-size: 15px;
      margin-left: 16px;
      margin-top: 10px;
      line-height: 30px;
      padding: 0px;
    }
  }
  .plan-main {
    display: flex;
    box-sizing: border-box;
    overflow: auto;
    padding-top: 10px;
    .left-step {
      flex-shrink: 0;
      width: 200px;
      margin: 0 8px 0px 16px;
    }
    .plan-content {
      height: calc(100vh - 92px);
      width: 100%;
      box-sizing: border-box;
      position: relative;
      .content-scroll {
        overflow: auto;
        height: 100%;
        padding: 0px 454px 0px 8px;
        box-sizing: border-box;
        // &::-webkit-scrollbar {
        //   display: none; /* Chrome Safari */
        //   scrollbar-width: none;
        //   -ms-overflow-style: none;
        // }
        .plan-center-content {
          margin: 0 auto;
        }
        .num-table-wrap {
          position: absolute;
          right: 32px;
          top: 0px;
          width: 422px;
        }
        .button-list {
          padding: 32px 0;
          .my-btn {
            width: 117px;
            height: 40px;
            &.border-btn {
              border: 1px solid rgba(24, 144, 255, 1);
              color: rgba(24, 144, 255, 1);
            }
          }
        }
      }
    }
  }
}

.modal-body {
  .radio-group {
    /deep/ .el-radio__input.is-checked .el-radio__inner {
      color: rgba(24, 144, 255, 1);
      border-color: rgba(24, 144, 255, 1);
      background: rgba(24, 144, 255, 1);
    }
    /deep/ .el-radio__input.is-checked + .el-radio__label {
      color: rgba(24, 144, 255, 1);
    }
  }
  .footer-wrap {
    text-align: right;
    display: block;
    padding-bottom: 24px;
  }
}
</style>
<style>
.el-loading-mask {
  z-index: 10000000;
}
</style>